import amazonCA from 'app/assets/images/icons/amazon-ca-icon.svg';
import amazonDE from 'app/assets/images/icons/amazon-de-icon.svg';
import amazonES from 'app/assets/images/icons/amazon-es-icon.svg';
import amazonFR from 'app/assets/images/icons/amazon-fr-icon.svg';
import amazonGB from 'app/assets/images/icons/amazon-gb-icon.svg';
import amazonIT from 'app/assets/images/icons/amazon-it-icon.svg';
import amazonMX from 'app/assets/images/icons/amazon-mx-icon.svg';
import amazonNone from 'app/assets/images/icons/amazon-none-icon.svg';
import amazonUK from 'app/assets/images/icons/amazon-uk-icon.svg';
import amazonUS from 'app/assets/images/icons/amazon-us-icon.svg';
// import amazonBR from 'app/assets/images/icons/amazon-br-icon.svg';
// import amazonIE from 'app/assets/images/icons/amazon-ie-icon.svg';
// import amazonBE from 'app/assets/images/icons/amazon-be-icon.svg';
// import amazonNL from 'app/assets/images/icons/amazon-nl-icon.svg';
// import amazonSE from 'app/assets/images/icons/amazon-se-icon.svg';
// import amazonTR from 'app/assets/images/icons/amazon-tr-icon.svg';
// import amazonSA from 'app/assets/images/icons/amazon-sa-icon.svg';
// import amazonAE from 'app/assets/images/icons/amazon-ae-icon.svg';
// import amazonIN from 'app/assets/images/icons/amazon-in-icon.svg';
// import amazonZA from 'app/assets/images/icons/amazon-za-icon.svg';
// import amazonPL from 'app/assets/images/icons/amazon-pl-icon.svg';
// import amazonEG from 'app/assets/images/icons/amazon-eg-icon.svg';
import NorthAmericaIcon from 'app/assets/images/icons/north-america.svg';
import EuropeIcon from 'app/assets/images/icons/europe.svg';
// import FarEastIcon from 'app/assets/images/icons/far-east.svg';

export interface MarketplaceData {
  id: string;
  countryCode: string;
  country: string;
  icon: string;
}

export interface RegionData {
  name: string;
  regionCode: string;
  icon: string;
  authUrl: string;
  defaultMarketplaceId?: string;
  marketplaces: MarketplaceData[];
}

export const CONNECTION_MARKETPLACE_REGIONS: RegionData[] = [
  {
    name: 'North America',
    regionCode: 'na',
    icon: NorthAmericaIcon,
    authUrl: 'https://sellercentral.amazon.com/apps/authorize/consent',
    defaultMarketplaceId: 'ATVPDKIKX0DER', // USA marketplace ID
    marketplaces: [
      { id: 'A2EUQ1WTGCTBG2', countryCode: 'CA', country: 'Canada' , icon: amazonCA},
      { id: 'ATVPDKIKX0DER', countryCode: 'US', country: 'USA' , icon: amazonUS},
      { id: 'A1AM78C64UM0Y8', countryCode: 'MX', country: 'Mexico' , icon: amazonMX},
      // { id: 'A2Q3Y263D00KWC', countryCode: 'BR', country: 'Brazil' , icon: amazonBR},
    ]
  },
  {
    name: 'Europe',
    regionCode: 'eu',
    icon: EuropeIcon,
    authUrl: 'https://sellercentral.amazon.co.uk/apps/authorize/consent',
    defaultMarketplaceId: 'A1F83G8C2ARO7P', // UK marketplace ID
    marketplaces: [
      // { id: 'A28R8C7NBKEWEA', countryCode: 'IE', country: 'Ireland' , icon: amazonIE},
      { id: 'A1RKKUPIHCS9HS', countryCode: 'ES', country: 'Spain' , icon: amazonES},
      { id: 'A1F83G8C2ARO7P', countryCode: 'UK', country: 'United Kingdom' , icon: amazonUK},
      { id: 'A13V1IB3VIYZZH', countryCode: 'FR', country: 'France' , icon: amazonFR},
      // { id: 'AMEN7PMS3EDWL', countryCode: 'BE', country: 'Belgium' , icon: amazonBE},
      // { id: 'A1805IZSGTT6HS', countryCode: 'NL', country: 'Netherlands' , icon: amazonNL},
      { id: 'A1PA6795UKMFR9', countryCode: 'DE', country: 'Germany' , icon: amazonDE},
      { id: 'APJ6JRA9NG5V4', countryCode: 'IT', country: 'Italy' , icon: amazonIT},
      // { id: 'A2NODRKZP88ZB9', countryCode: 'SE', country: 'Sweden' , icon: amazonSE},
      // { id: 'AE08WJ6YKNBMC', countryCode: 'ZA', country: 'South Africa' , icon: amazonZA},
      // { id: 'A1C3SOZRARQ6R3', countryCode: 'PL', country: 'Poland' , icon: amazonPL},
      // { id: 'ARBP9OOSHTCHU', countryCode: 'EG', country: 'Egypt' , icon: amazonEG},
      // { id: 'A33AVAJ2PDY3EV', countryCode: 'TR', country: 'Turkey' , icon: amazonTR},
      // { id: 'A17E79C6D8DWNP', countryCode: 'SA', country: 'Saudi Arabia' , icon: amazonSA},
      // { id: 'A2VIGQ35RCS4UG', countryCode: 'AE', country: 'United Arab Emirates' , icon: amazonAE},
      // { id: 'A21TJRUUN4KGV', countryCode: 'IN', country: 'India' , icon: amazonIN}
    ]
  },
  // {
  //   name: 'Far East',
  //   endpoint: 'https://sellingpartnerapi-fe.amazon.com',
  //   sellerCentralDomain: 'sellercentral-japan.amazon.com',
  //   awsRegion: 'us-west-2',
  //   icon: FarEastIcon,
  //   marketplaces: [
  //     { id: 'A19VAU5U5O7RUS', countryCode: 'SG', country: 'Singapore' },
  //     { id: 'A39IBJ37TRP1C6', countryCode: 'AU', country: 'Australia' },
  //     { id: 'A1VC38T7YXB528', countryCode: 'JP', country: 'Japan' }
  //   ]
  // }
];

export type MarketplaceFilter = {
  label: string;
  marketplace_id: Marketplace;
};

export enum Marketplace {
  US = 'US',
  CA = 'CA',
  GB = 'GB',
  MX = 'MX',
  UK = 'UK',
  DE = 'DE',
  IT = 'IT',
  ES = 'ES',
  FR = 'FR',
}

export const marketProperty = {
  [Marketplace.US]: {
    flag: amazonUS,
    label: 'amazon.com',
    host: 'amazon.com',
    currency: '$',
  },
  [Marketplace.CA]: {
    flag: amazonCA,
    label: 'amazon.ca',
    host: 'amazon.ca',
    currency: '$',
  },
  [Marketplace.GB]: {
    flag: amazonGB,
    label: 'amazon.gb',
    host: 'amazon.gb',
    currency: '$',
  },
  [Marketplace.MX]: {
    flag: amazonMX,
    label: 'amazon.com.mx',
    host: 'amazon.com.mx',
    currency: '$',
  },
  [Marketplace.UK]: {
    flag: amazonUK,
    label: 'amazon.co.uk',
    host: 'amazon.co.uk',
    currency: '£',
    hasNew: [],
    hasBeta: [],
  },
  [Marketplace.DE]: {
    flag: amazonDE,
    label: 'amazon.de',
    host: 'amazon.de',
    currency: '€',
    hasBeta: [],
    hasNew: [],
    disabledPages: [],
  },
  [Marketplace.IT]: {
    flag: amazonIT,
    label: 'amazon.it',
    host: 'amazon.it',
    currency: '€',
    hasBeta: [],
    hasNew: [],
    disabledPages: [],
  },
  [Marketplace.ES]: {
    flag: amazonES,
    label: 'amazon.es',
    host: 'amazon.es',
    currency: '€',
    hasBeta: [],
    hasNew: [],
    disabledPages: [],
  },
  [Marketplace.FR]: {
    flag: amazonFR,
    label: 'amazon.fr',
    host: 'amazon.fr',
    currency: '€',
    hasBeta: [],
    hasNew: [],
    disabledPages: [],
  },
};

export const getSupportedMarketplaces = () => {
  return Object.keys(marketProperty).filter(
    (marketplace) => marketplace !== Marketplace.GB,
  );
};

export const getFlag = (id: Marketplace | string) => {
  return marketProperty[id]?.flag || amazonNone;
};

export const getAmazonLabel = (id: Marketplace) => {
  return marketProperty[id]?.label || marketProperty[Marketplace.US].label;
};

export const getAmazonHost = (id: Marketplace) => {
  return marketProperty[id]?.host || marketProperty[Marketplace.US].host;
};

export const optionsMarketplace = Object.keys(marketProperty)
  .filter((marketplace) => marketplace !== Marketplace.GB)
  .map((marketplace) => {
    const value = marketProperty[marketplace];
    return {
      label: value.label,
      marketplace_id: marketplace,
      hasNew: value.hasNew,
      hasBeta: value.hasBeta,
      disabledPages: value.disabledPages,
    };
  });

export const getCurrencySymbol = (marketplace_id: Marketplace) => {
  return (
    marketProperty[marketplace_id]?.currency ||
    marketProperty[Marketplace.US].currency
  );
};

export const sortListProjectMarketplace = (
  projects: any[],
  projectId: string,
) => {
  const sortListProjectMarketplace: any[] = [];
  const findProject = projects?.find(
    (project) => project.project_id === projectId,
  );
  if (findProject?.link_id) {
    const listProjectMarketplace =
      projects?.filter((item) => item.link_id === findProject?.link_id) || [];

    optionsMarketplace.forEach((item) => {
      const pr = listProjectMarketplace.find(
        (i) => i.marketplace === item.marketplace_id,
      );
      pr && sortListProjectMarketplace.push(pr);
    });
  }
  return sortListProjectMarketplace;
};

export const getProjectWithMarketPlace = (list: any[], marketplace: string) => {
  return list.find((item) => item.marketplace === marketplace);
};

export const getProjectSelected = (project: any) => {
  let projectSelected = project;
  if (project.list_marketplace) {
    for (let i = 0; i < optionsMarketplace.length; i++) {
      const pr = getProjectWithMarketPlace(
        project.list_marketplace,
        optionsMarketplace[i].marketplace_id,
      );
      if (pr) {
        projectSelected = pr;
        break;
      }
    }
  }
  return projectSelected;
};

export const getAsinAmazonURL = (marketplace: Marketplace, asin: string) => {
  return `https://www.${getAmazonLabel(marketplace)}/dp/${asin}`;
};

export const getFlagByCountryCode = (countryCode: string): string => {
  for (const region of CONNECTION_MARKETPLACE_REGIONS) {
    const marketplace = region.marketplaces.find(
      (m) => m.countryCode.toLowerCase() === countryCode.toLowerCase()
    );
    if (marketplace) {
      return marketplace.icon;
    }
  }
  return amazonNone; // Return default icon if no match found
};
